
import { mapState } from "vuex";
import { pathOr } from "ramda";

export default {
  props: {
    tiles: { type: Array, default: () => [] },
    selectedTile: { type: String, default: "" },
    isSingleSizeSelected: { type: Boolean, default: false },
    label: { type: String, default: "" },
  },

  data() {
    return { internalSelectedTile: this.selectedTile };
  },

  computed: {
    ...mapState("pdp", ["variantLoading"]),
    ...mapState({
      order: s => s.siteConfig.pdp.comfortFeelOrder,
      mattressLabel: s => s.siteConfig.pdp.mattressFeelLabel,
    }),
    labelText() {
      return this.isSingleSizeSelected
        ? "Mattress Feel"
        : pathOr("", [this.label], this.mattressLabel);
    },
    sortedTiles() {
      const { order } = this;

      return this.tiles.slice().sort((a, b) => {
        const aLabel = a?.tileLabel?.toLowerCase();
        const bLabel = b?.tileLabel?.toLowerCase();

        return (order[aLabel] ?? Infinity) - (order[bLabel] ?? Infinity);
      });
    },
    sisAttributeName() {
      return "data-sis-" + this.labelText.replace(/\s+/g, "-")?.toLowerCase();
    },
  },

  watch: {
    selectedTile(value) {
      this.internalSelectedTile = value;
    },
  },

  methods: {
    handleClick(targetVariantId, tileLabel) {
      this.internalSelectedTile = tileLabel;
      this.$emit("select-variant-id", targetVariantId);
    },
  },
};
